import { useTranslation } from '@common/hooks/translation';

import './style.scss';

interface IProps {
  title?: string;
  className?: string;
}

const EmptySearch = ({ title, className = '' }: IProps) => {
  const t = useTranslation();

  return (
    <div className={`C-empty-search ${className}`}>
      <i className="global-icon icon-search-no-result" />
      <span>{t(title || 'No result')}</span>
    </div>
  );
};

export default EmptySearch;
